import { useTranslation } from 'react-i18next';
import { Header, IconAirtm, IconButton, List, Close } from '@airtm/airtm-ui';
import { Link, useLocation } from 'react-router-dom';
import formatNumber from 'utils/formatNumber';
import useBalance from 'utils/hooks/useBalance/useBalance';
import Notifications from './Notifications';
import Balance from './Balance';

type Props = {
  className?: string;
  onToggleSideNav: (isShow: boolean) => void;
  showMobileNav?: boolean;
};

const HeaderComponent = function ({
  className = '',
  onToggleSideNav,
  showMobileNav = false,
}: Props) {
  const { t } = useTranslation('LAYOUT');
  const { balance, hideBalances, toggleBalanceVisibility } = useBalance();
  const location = useLocation();
  const isHomePage = location.pathname === '/home';
  if (!balance) {
    return null;
  }

  return (
    <Header id="header" className={className} isHomeHeader={isHomePage}>
      <Header.Brand>
        <Link to="/">
          <IconAirtm className="text--black mt-0" />
        </Link>
      </Header.Brand>
      <Header.Balance data-testid="balance-toggle-header">
        <Balance
          onToggleShowHideBalance={toggleBalanceVisibility}
          breakdownTotalBalanceLabel={t('LAYOUT:BALANCE_TOTAL_BALANCE_LABEL')}
          balance={formatNumber(balance?.amount || 0, 'USDC', '$')}
          hideBalances={hideBalances}
        />
      </Header.Balance>
      <Header.Content>
        <Notifications />
        <IconButton
          className="d-block d-sm-none"
          size="sm"
          onClick={() => {
            onToggleSideNav(!showMobileNav);
          }}
          icon={showMobileNav ? <Close /> : <List />}
        />
      </Header.Content>
    </Header>
  );
};

export default HeaderComponent;
